import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorMemorySutaible,
  fetchProcessorMemorySutaibleAttributes,
  fetchProcessorMemorySutaibleFromFactorById,
  updateProcessorMemorySutabile,
  updateStatusInProcessorMemorySutaible,
} from "./thunk";

interface CategoryState {
  processor_memory_sutaible_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_memory_sutaible_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "processor_memory_sutaible",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorMemorySutaibleAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorMemorySutaibleAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_memory_sutaible_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorMemorySutaibleAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Categories";
      })
      .addCase(fetchProcessorMemorySutaibleFromFactorById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorMemorySutaibleFromFactorById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorMemorySutaibleFromFactorById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorMemorySutaible.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_memory_sutaible_list = state.processor_memory_sutaible_list.map((processor_memory_sutaible) =>
          processor_memory_sutaible.id === action.payload.id ? action.payload : processor_memory_sutaible
        );
      })
      .addCase(addProcessorMemorySutaible.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Processor MotherBoards Chips";
      })
      .addCase(updateProcessorMemorySutabile.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_memory_sutaible_list = state.processor_memory_sutaible_list.map((processor_memory_sutaible) =>
          processor_memory_sutaible.id === action.payload.id ? action.payload : processor_memory_sutaible
        );
      })
      .addCase(updateStatusInProcessorMemorySutaible.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorMemorySutaible.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
